import script from "./PreviewVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewVideo.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewVideo.vue?vue&type=style&index=0&id=34c9b341&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34c9b341"]])

export default __exports__